module.exports = __webpack_public_path__ + "static/politicas-e7f8f3d9c40006a8930492c790395312.jpg";